class PrismCam {
  constructor(rootElement) {
    this.camContainer = rootElement.querySelector('.js-prismcam-cam-container');
    this.cams = rootElement.querySelectorAll('.js-prismcam-cam');
    this.camButtons = rootElement.querySelectorAll('.js-prismcam-cam-select');

    this.camButtons.forEach(camButton => {
      camButton.addEventListener('click', (event) => {
        this.selectCam(event.target.dataset.camId);

        this.camButtons.forEach(camButton => {
          camButton.classList.remove('--active');
        });

        event.target.classList.add('--active');
      });
    });
  }

  selectCam(camId) {
    const camsArray = [...this.cams];

    camsArray.forEach(cam => {
      cam.classList.remove('--enabled');
    });

    let selectedCams = camsArray.filter(cam => cam.dataset.camId == camId);

    if (selectedCams.length == 1) {
      let selectedCam = selectedCams[0];
      selectedCam.classList.add('--enabled');
    }
  }

}

document.addEventListener("DOMContentLoaded", function() {
  const prismcamElement = document.querySelector('.js-prismcam');
  if (prismcamElement != null) {
    new PrismCam(prismcamElement)
  }
});
